export default [
  {
    duration: 3,
    start: 0,
    end: 477,
    decimals: 0,
    postfix: 'врачей&nbsp;&mdash;',
    description: 'молодых специалистов пришли работать в медицинские учреждения Брянской области с&nbsp;2013 по 2017 год.',
    image: require('./assets/photo/topics/young-doctors-m.jpg'),
    cite: {
      text: 'Смысл всей нашей политики&nbsp;&mdash; это сбережение людей, умножение человеческого капитала как главного богатства России. Поэтому наши усилия направлены на&nbsp;поддержку традиционных ценностей и&nbsp;семьи, на&nbsp;демографические программы, улучшение экологии, здоровья людей, развитие образования и&nbsp;культуры.',
      description: 'Послание Президента Федеральному Собранию, 1&nbsp;декабря 2016 года'
    }
  },
  {
    duration: 3,
    start: 0,
    end: 240,
    decimals: 0,
    postfix: 'специалистов',
    description: 'получили выплату в&nbsp;размере 1&nbsp;млн&nbsp;рублей с&nbsp;2012 года в&nbsp;рамках реализации федеральной программы &laquo;Земский доктор&raquo;. ',
    image: require('./assets/photo/topics/lopazna-m.jpg')

  },
  {
    duration: 3,
    start: 0,
    end: 82,
    decimals: 0,
    postfix: 'автомобиля',
    description: 'скорой помощи получили учреждения здравоохранения Брянской области с&nbsp;2015&nbsp;года.',
    image: require('./assets/photo/topics/ambulance-m.jpg')
  },
  {
    duration: 3,
    start: 0,
    end: 94,
    decimals: 0,
    postfix: 'автобуса,',
    description: 'сертифицированных для перевозки детей, переданы общеобразовательным учреждениям  Брянской области за&nbsp;последние 2&nbsp;года.',
    image: require('./assets/photo/topics/schoolbus-m.jpg')
  },
  {
    duration: 3,
    start: 0,
    end: 135,
    decimals: 0,
    postfix: ' участников',
    description: 'представили Брянскую область на&nbsp;XIX Всемирном фестивале молодежи и&nbsp;студентов.',
    image: require('./assets/photo/topics/sochi-2017-m.jpg')
  },
  {
    duration: 3,
    start: 0,
    end: 9677,
    decimals: 0,
    postfix: ' рублей',
    description: 'будут ежемесячно получать семьи в&nbsp;Брянской области при рождении (усыновлении) первого ребенка после 1 января 2018 года, в&nbsp;случае если среднедушевой доход семьи не&nbsp;превышает прожиточный минимум в&nbsp;полтора раза. Решение о&nbsp;назначении выплат принято Президентом РФ&nbsp;В. Путиным на&nbsp;заседании Координационного совета по&nbsp;реализации Национальной стратегии действий в&nbsp;интересах детей 28 ноября 2017 года.',
    image: require('./assets/photo/topics/perinatal-putin-m.jpg'),
    cite: {
      text: 'Среди мер, которые были введены и&nbsp;которые работают до&nbsp;сих пор, особую роль сыграла программа материнского капитала. <..> Иметь в&nbsp;семье двух детей стало устойчивой тенденцией. Снизилась младенческая смертность, благодаря созданию системы перинатальных центров, прежде всего, удалось выйти на&nbsp;плюсовые показатели естественного прироста населения.',
      description: 'Заседание Координационного совета по&nbsp;реализации Национальной стратегии действий в&nbsp;интересах детей, 29&nbsp;ноября&nbsp;2017&nbsp;года'
    }
  },
  {
    duration: 3,
    start: 50000,
    end: 65449,
    decimals: 0,
    postfix: 'сертификатов',
    description: 'выдано в Брянской области на материнский семейный капитал c 1 января 2007 года. В 2018 году материнский капитал составляет 453 026 рублей и выдается при при рождении или усыновлении второго, третьего или последующего ребёнка.',
    image: require('./assets/photo/topics/perinatal-m.jpg')
  },
  {
    duration: 3,
    start: 0,
    end: 100,
    decimals: 0,
    postfix: '% детей',
    description: 'в&nbsp;возрасте от&nbsp;3 до&nbsp;7 лет обеспечены местами в&nbsp;детских садах Брянской области.',
    image: require('./assets/photo/topics/kindergarten-m.jpg')
  },
  {
    duration: 3,
    start: 0,
    end: 249.3,
    decimals: 1,
    postfix: '&nbsp;млн&nbsp;рублей',
    description: 'получила Брянская область благодаря системе &laquo;Платон&raquo; на&nbsp;ремонт дорог и&nbsp;мостов.',
    image: require('./assets/photo/topics/bridge-m.jpg'),
    cite: {
      text: '&laquo;Одним из&nbsp;приоритетов в&nbsp;работе Правительства, вообще государства в&nbsp;ближайшее время должна стать работа над развитием инфраструктуры. Это дорожная сеть, аэропорты, порты, связь.&raquo',
      description: 'Ежегодная пресс-конференция Президента России, 14&nbsp;декабря&nbsp;2017&nbsp;года'
    }
  },
  {
    duration: 3,
    start: 0,
    end: 510,
    decimals: 0,
    postfix: 'км автодорог',
    description: 'будет построено и&nbsp;капитально отремонтировано в&nbsp;2018 году (в&nbsp;2017 году&nbsp;&mdash; 470&nbsp;км). Объем строительства и&nbsp;ремонта дорог вырос более чем в&nbsp;три раза, хотя бюджет дорожного фонда увеличился только на&nbsp;40%.',
    image: require('./assets/photo/topics/road-m.jpg')
  },
  {
    duration: 3,
    start: 0,
    end: 300,
    decimals: 0,
    postfix: 'населенных пунктов',
    description: 'с&nbsp;численностью жителей от&nbsp;250 до&nbsp;500 человек будут подключены к&nbsp;высокоскоростному Интернету благодаря соглашению между Минкомсвязью, Брянской областью и&nbsp;<nobr>ПАО &laquo;Ростелеком&raquo;</nobr>.',
    image: require('./assets/photo/topics/internet-m.jpg')
  }
]



// WEBPACK FOOTER //
// ./src/indicators.js